export default __webpack_public_path__ + "static/media/aave.7a37d675.svg";